import { Flex, Text, Icon } from "@chakra-ui/react";
import { IconType } from "react-icons";

// A single selectable option card — the recurring pattern across the real
// Wobble service-creator screen (category / schedule / price / location /
// waitlist / booking-rules all use this exact shape). Pulled into one
// component instead of copy-pasting the card markup six times.
type OptionCardProps = {
  icon?: IconType;
  title: string;
  description: string;
  selected: boolean;
  onClick: () => void;
};

const OptionCard = ({ icon, title, description, selected, onClick }: OptionCardProps) => (
  <Flex
    as="button"
    type="button"
    onClick={onClick}
    direction="column"
    align="center"
    textAlign="center"
    flex="1"
    minW="0"
    border="1.5px solid"
    borderColor={selected ? "wobble.600" : "chalk.300"}
    bg={selected ? "wobble.50" : "white"}
    borderRadius="lg"
    px={2}
    py={2.5}
    gap={1}
    transition="all 0.15s ease"
  >
    {icon && <Icon as={icon} boxSize="13px" color={selected ? "wobble.600" : "ink.900"} mb={0.5} />}
    <Text fontSize="8px" fontWeight="700" color="ink.900" noOfLines={1}>
      {title}
    </Text>
    <Text fontSize="7px" color="slate.500" lineHeight="1.4" noOfLines={3}>
      {description}
    </Text>
  </Flex>
);

export default OptionCard;
